import { render } from "./pay-review.vue?vue&type=template&id=a3f72d8a&scoped=true"
import script from "./pay-review.vue?vue&type=script&lang=js"
export * from "./pay-review.vue?vue&type=script&lang=js"

import "./pay-review.vue?vue&type=style&index=0&id=a3f72d8a&lang=less&scoped=true"

import exportComponent from "/root/project/msp-fronted/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a3f72d8a"]])

export default __exports__